module.exports = __webpack_public_path__ + "img/empty_tips.76841feb.png";